<div class="main-div">
<section>
        <div class="faciliate-heading">
            <h3>{{faciliateData.heading}}</h3>
        </div>

    <div class="confirm-section">
        <div class="confirm-info">
            <div class="confirm-blocks">
                <pre class="confirm-block-heading">{{faciliateData.firstName}} {{firstName}}</pre>
            </div>
            <div class="confirm-blocks">
                <pre class="confirm-block-heading">{{faciliateData.lastName}} {{lastName}}</pre>
            </div>
            <div class="confirm-blocks">
                <pre class="confirm-block-heading">{{faciliateData.email}} {{userEmail}}</pre>
            </div>
        </div>
    </div>


</section>
<div class="abm-faciliate-info">
    <p>{{faciliateData.description1}}</p>
  </div>

  <div class="abm-faciliate-info">
    <p>For more information, refer to <a href="https://support.apple.com/guide/apple-business-manager/welcome/web" target="_blank">Apple Business User Guide </a></p>
  </div>


    <div class="abmlegalAgreement">
        <h3>{{faciliateData.ackHeading}}</h3>
        <br/>
        <p>{{faciliateData.ackDescription}}</p>

         <p>
            <label class="checkbox">
                <input type="checkbox" (change)="checkConfirmation($event)">
                <i class="skin"></i>
                <span>{{faciliateData.checkboxDescription}}</span>
            </label>
        </p>
    </div>
  <br>
  <div class="continue-section">
    <button class="btn btn-secondary" id="continue-option" [disabled]="!this.selectedbox" [routerLink]="['/signupsetup/enrollmentoptions']"
        >{{faciliateData.continue}}</button><a id="cancel-option" [routerLink]="['/productselection']">{{faciliateData.cancel}}</a>
</div>
</div>  

